

import { getUserInfo } from "@/model/user"
const getDefaultState = () => {
    return {
        //用户信息
        userInfo: {},
        //权限信息
        permissions: null,
        //菜单tab 权限
        feature:[]
    }
}

const state = getDefaultState()

//操作管理
const mutations = {
    // 设置登录用户信息
    SET_LOGIN(state, data = null) {
        state.userInfo = data
    },

    // 设置权限信息
    SET_PERMS(state, data = null) {
        state.permissions = data

        // 管理员额外追加特殊权限
        if(state.userInfo?.adminFlag === '1'){
          state.permissions.push('adminFlag')
      }
    },

    //设置非路由权限 菜单
    SET_FEATURE(state,data = null){
        state.feature = data
    }

}

//异步操作
const actions = {
    // 获取当前登录人信息
    async saveLogin({ commit }, data = null) {
        // console.log(data,'data-=============')
        commit('SET_FEATURE',data?.featurePermissionsList)
        commit('SET_LOGIN', data?.user)
        commit('SET_PERMS', data?.permissions)
    },

    layout({ commit }) {
        commit('SET_LOGIN', {})
        commit('SET_PERMS', null)
        commit('SET_FEATURE',null)
    },

    //更新用户信息
    async updateUser({ commit }) {
        const res = await getUserInfo({source:'1'})
        if (+res.code === 200) {
            // const userInfo = {
            //     user: res?.user,
            //     permissions: res?.permissions || []
            // }
            commit('SET_FEATURE',res?.featurePermissionsList)
            commit("SET_LOGIN", res?.user)
            commit('SET_PERMS', res?.permissions)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
